// Display name for a booking. The name typed at booking time
// (bookings.guest_name) wins over the customer record's first/last name;
// counter walk-ins may have no customer at all (customer_id NULL), in which
// case guest_name is the only name we have. Returns '' when nothing is
// known so callers pick their own placeholder ('—', 'Geen klantgegevens', …).

export interface BookingNameSource {
  guest_name?: string | null;
  customers?: {
    first_name?: string | null;
    last_name?: string | null;
  } | null;
}

export function bookingDisplayName(b: BookingNameSource): string {
  const guest = b.guest_name?.trim();
  if (guest) return guest;
  const c = b.customers;
  if (!c) return '';
  return [c.first_name, c.last_name]
    .map((s) => (s ?? '').trim())
    .filter(Boolean)
    .join(' ');
}
